import { Component, EventEmitter } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { PurchaseOrder } from '../../../../../data/models';

@Component({
    selector: 'app-job-invoices-delete-order-modal',
    templateUrl: './job-invoices-delete-order-modal.component.html',
    standalone: false,
})
export class JobInvoicesDeleteOrderModalComponent {
    option = 'order';
    // @ts-ignore TS2564
    order: PurchaseOrder;
    action = new EventEmitter<any>();

    constructor(private bsModalRef: BsModalRef) {}

    ok() {
        this.bsModalRef.hide();
        this.action.emit({ cancelled: false, option: this.option, order: this.order });
    }

    cancel() {
        this.bsModalRef.hide();
        this.action.emit({ cancelled: true });
    }
}
